// angular.module('HeroPRO')
//     .provider('raSmarty', raSmarty);

const smartyDefaults = {
    authID: '2619780531663440111',
    suggestions: '4',
    errorMessage: "Hmm, didn't find a match for this address.",
    noSuggestionsMessage: 'No more suggestions...',
};

/* @ngInject */
export default function raSmarty(HPConfig) {
    const p = this;
    let config;

    p.configure = function (_config) {
        config = _config;
    };

    p.$get = function ($http, $q) {
        const Smarty = function (_config) {
            this.config = angular.extend({}, smartyDefaults, _config);
        };

        Smarty.prototype.getAddress = function (address, stateFilter) {
            if (HPConfig.splashMtnEnabled === 'true') {
                return getSplashMountainSuggestions(HPConfig, $http, address).then(result => processSplashMtnResults(result.data.addresses));
            } else if (HPConfig.splashMtnEnabled === 'both') {
                const splashMountainSuggestionsPromise = getSplashMountainSuggestions(HPConfig, $http, address);
                const smartySuggestionsPromise = getSmartySuggestions($http, this.config, address, stateFilter);
                let splashMountainSuggestions;
                let smartySuggestions;
                splashMountainSuggestionsPromise.then((response) => {
                    // console.log("splashMountainSuggestions",response);
                    splashMountainSuggestions = response.data.addresses;
                });
                smartySuggestionsPromise.then((response) => {
                    // console.log("smartySuggestions",response);
                    smartySuggestions = response.data;
                });
                const config = this.config;
                return $q.all([splashMountainSuggestionsPromise, smartySuggestionsPromise]).then(() => {
                    const combinedResults = combineResults(processSplashMtnResults(splashMountainSuggestions).suggestions, smartySuggestions.suggestions, config.suggestions);
                    return combinedResults;
                });
            }
            return getSmartySuggestions($http, this.config, address, stateFilter).then(result => result.data);
        };

        // TODO: Make endpoint available in the config phase
        Smarty.prototype.verifyAddress = function (street, secondary, city, state, propertyId, source) {
            let url,
                http;
            let headers = {
                'Content-Type': 'application/json',
            };
            if (source === 'splash') {
                url = `${HPConfig.splashMtnUrl}/propertyprofiles/${encodeURIComponent(propertyId)}`;
                headers = {
                    'Content-Type': 'application/json',
                    'X-RACtx': undefined,
                    'X-Requested-With': undefined,
                    'x-api-key': HPConfig.splashMtnApiKey,
                };
                http = $http({
                    url,
                    method: 'GET',
                    headers,
                    withCredentials: false,
                });
                return http.then(result => processSplashMtnVerifyResults(result));
            }
            if (secondary === undefined || secondary === null) {
                url = `${HPConfig.heroProApi}Address/VerifyWithSmarty?street=${processAddress(street)}&city=${processAddress(city)}&state=${state}`;
            } else {
                url = `${HPConfig.heroProApi}Address/VerifyWithSmarty?street=${processAddress(street)}&secondary=${processAddress(secondary)}&city=${processAddress(city)}&state=${state}`;
            }
            http = $http({
                url,
                method: 'GET',
                headers,
                withCredentials: false,
            });
            return http;
        };

        return new Smarty(config);
    };
    p.$get.$inject = ['$http', '$q'];
}

function getSmartySuggestions($http, config, address, stateFilter) {
    return $http({
        // url: 'https://autocomplete-api.smartystreets.com/suggest?auth-id=' + config.authID + '&prefix=' + processAddress(address) + '&suggestions=' + config.suggestions,
        url: `https://autocomplete-api.smartystreets.com/suggest?auth-id=${config.authID}&prefix=${processAddress(address)}&state_filter=${stateFilter}&suggestions=${config.suggestions}`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-RACtx': undefined,
            'X-Requested-With': undefined,
        },
        withCredentials: false,
    });
}

function getSplashMountainSuggestions(HPConfig, $http, address) {
    return $http({
        url: `${HPConfig.splashMtnUrl}/propertyprofiles/lookup?address=${encodeURIComponent(address)}`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-RACtx': undefined,
            'X-Requested-With': undefined,
            'x-api-key': HPConfig.splashMtnApiKey,
        },
        withCredentials: false,
    });
}

function combineResults(splashMountainSuggestions, smartySuggestions, maxResultCount) {
    splashMountainSuggestions = splashMountainSuggestions !== null ? splashMountainSuggestions : [];
    smartySuggestions = smartySuggestions !== null ? smartySuggestions : [];

    const results = splashMountainSuggestions.slice(0);

    const numberOfSmartyResultsToKeep = maxResultCount - splashMountainSuggestions.length;
    let smartyAdded = 0;
    for (let i = 0; i < smartySuggestions.length && smartyAdded < numberOfSmartyResultsToKeep; i++) {
        smartySuggestions[i].text = smartySuggestions[i].text.toUpperCase();
        const compareAgainst = smartySuggestions[i].text.split(',')[0];
        let found = false;
        for (let j = 0; j < splashMountainSuggestions.length; j += 1) {
            if (splashMountainSuggestions[j].text.indexOf(compareAgainst) >= 0) {
                found = true;
                break;
            }
        }

        if (found === false) {
            smartySuggestions[i].source = 'smarty';
            results.push(smartySuggestions[i]);
            smartyAdded++;
            if (results.length === maxResultCount) {
                break;
            }
        }
    }


    return { suggestions: results };
}

function processAddress(address) {
    let encodedAddress = '';
    if (address !== undefined && address.length > 0) {
        const addressComponents = address.split(' ');
        for (let index = 0; index < addressComponents.length; index++) {
            encodedAddress += encodeURIComponent(addressComponents[index]);
            if (index < addressComponents.length - 1) {
                encodedAddress += '+';
            }
        }
    }
    return encodedAddress;
}

function processSplashMtnResults(results) {
    if (results.length <= 0) {
        return { suggestions: null };
    }
    const newResults = [];
    const max = results.length > 4 ? 4 : results.length;
    for (let i = 0; i < results.length; i++) {
        const addressBreakout = results[i].address.split(',');
        const propertyKeyBreakout = results[i].propertyKey.split('_');
        const item = {
            street_line: addressBreakout[0].trim(),
            // we can't assume there will be a city, addressBreakout may only have two
            // items in the array ([address_line, who_knows_what]) if there is a second comma
            // (three items in the array) then we can assume the second position is a city ([address_line, city, who_knows_what])
            // who_knows_what could be state and/or zip
            city: addressBreakout.length > 2 ? addressBreakout[1].trim() : '',
            // we can be sure state is in position 6 on the property key, assuming no changes to splash mtn
            state: propertyKeyBreakout[6],
            zip: propertyKeyBreakout[7],
            text: results[i].address,
            propertyId: results[i].propertyProfileId,
            source: 'splash',
        };

        // must have city and zip
        if (item.zip && item.zip !== '' && item.city && item.city !== '') {
            newResults.push(item);
        }

        if (newResults.length === max) {
            i = results.length;
        }
    }
    return { suggestions: newResults };
}

function processSplashMtnVerifyResults(results) {
    if (!results.data) {
        return results;
    }
    const result = angular.copy(results.data);
    let line1 = result.AddressParts.HouseNumber;
    line1 += result.AddressParts.StreetPreDirection ? ` ${result.AddressParts.StreetPreDirection}` : '';
    line1 += ` ${result.AddressParts.Street}`;
    line1 += result.AddressParts.StreetSuffix ? ` ${result.AddressParts.StreetSuffix}` : '';
    line1 += result.AddressParts.StreetPostDirection ? ` ${result.AddressParts.StreetPostDirection}` : '';

    let lastLine = `${result.AddressParts.City}, ${result.AddressParts.State} ${result.AddressParts.ZipCode}`;
    const zipCode = result.AddressParts.ZipCode;
    lastLine += zipCode;

    // ra-smarty-streets.js expects a smart object
    const smartyObject = {
        Address: result.Address,
        delivery_line_1: line1,
        last_line: lastLine,
        analysis: { dpv_match_code: 'Y' },
        components: {
            primary_number: result.AddressParts.HouseNumber,
            city_name: result.AddressParts.City,
            state_abbreviation: result.AddressParts.State,
            secondary_number: result.AddressParts.StreetSecondaryNumber,
            zipcode: zipCode,
            plus4_code: result.AddressParts.ZipCodePlus4,
            street_name: result.AddressParts.Street,
            street_suffix: result.AddressParts.StreetSuffix,
            street_predirection: result.AddressParts.StreetPreDirection,
            street_postdirection: result.AddressParts.StreetPostDirection,
            apn: result.APN,
            fips_code: result.FIPSCode
        },
    };

    // replace the original splash mtn object with the smart object

    results.data.Data = [smartyObject];
    // reattach
    results.data.Data[0].splashMtnObject = result;

    return results;
}

function filterOutNonZipcodeSuggestions(addresses) {
    return addresses.suggestions.filter(address => address.zip);
}


// WEBPACK FOOTER //
// ./src/app/common/smarty/smarty-provider.js